"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenPreview = void 0;
const nft_view_1 = require("@components/nft-view");
const icons_1 = require("@shared-modules/components/icons");
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const unknown_png_1 = __importDefault(require("@assets/unknown.png"));
require("./styles.scss");
const translation_hooks_1 = require("@hooks/translation.hooks");
const TokenPreview = (props) => {
    const { nft: { metadata, mediaType, metaUrlBase, collection, collectionId }, } = props;
    const [isViewActive, setIsViewActive] = (0, react_1.useState)(false);
    const nftViewEventHandler = (event) => setIsViewActive(event === "play");
    const translator = (0, translation_hooks_1.usePagesTranslation)("tokenPage.tokenPreview");
    const collectionClasses = (0, classnames_1.default)("c-token-page-token-preview__collection", {
        "c-token-page-token-preview__collection--active": isViewActive,
    });
    return (react_1.default.createElement("div", { className: "c-token-page-token-preview" },
        !isViewActive && (react_1.default.createElement("div", { className: "c-token-page-token-preview__content-icon" },
            mediaType === "3d" && react_1.default.createElement(icons_1.ArtIcon, { scale: 1.4, color: "red" }),
            mediaType === "audio" && react_1.default.createElement(icons_1.AudioIcon, { scale: 1.4, color: "red" }),
            mediaType === "image" && react_1.default.createElement(icons_1.ImageIcon, { scale: 1.4, color: "red" }),
            mediaType === "video" && react_1.default.createElement(icons_1.VideoIcon, { scale: 1.4, color: "red" }))),
        react_1.default.createElement(nft_view_1.NftView, { mediaType: mediaType, metaUrlBase: metaUrlBase, metadata: metadata, eventHandler: nftViewEventHandler }),
        react_1.default.createElement("div", { className: collectionClasses },
            react_1.default.createElement("div", { className: "c-token-page-token-preview__collection-avatar", style: { backgroundImage: `url(${collection.previewUrl || unknown_png_1.default})` } }),
            react_1.default.createElement("div", { className: "c-token-page-token-preview__collection-info" },
                react_1.default.createElement("div", { className: "c-token-page-token-preview__collection-info-label" }, translator("collectionLabel")),
                react_1.default.createElement(react_router_dom_1.Link, { className: "g-link", to: `/collections/${collectionId}` }, collection.title)))));
};
exports.TokenPreview = TokenPreview;
